<template>
  <div class="c-culture-projects">
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0009_petit-palais.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>资助巴黎Petit Palais新展馆的修建</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>Petit Palais</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>基金会出资修建了巴黎小皇宫的新展馆，用以在Petit Palais博物馆的常设展览中展出东方基督教艺术的经典作品。该系列汇集了创作于15至19世纪来自希腊和俄罗斯的标志性作品，是该流派在法国规模较大的公共藏品系列。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.petitpalais.paris.fr/le-petit-palais/soutenir-le-petit-palais">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0008_street-art-13.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>支持Street Art 13艺术项目</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>STREET ART 13</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>Street Art 13项目涵盖了由多位法国和国际艺术家创作的壁画系列，并获得了基金会提供的资金支持。该项目由Itinerrance Gallery与巴黎第十三区市政厅合作推出，旨在通过这些创作将巴黎街头打造成一座露天博物馆。通过邀请知名都市艺术家自由表达创意，巴黎第十三区正在慢慢书写街头艺术史上瑰丽的篇章之一，并借此为该区打响国际知名度。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.streetart13.fr/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0007_notre-dame-de-lassomption.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>参与Notre-Dame de l'Assomption圣母升天大教堂的修复工作</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>NOTRE-DAME DE L'ASSOMPTION</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>基金会为Notre-Dame de l'Assomption教堂的穹顶壁画修复工作提供了资金援助。这座教堂座落位于 Rue Saint Honoré，于1844年成为巴黎波兰小区的礼拜场所。此壁画于17世纪由艺术家Charles Delafosse创作，他是Le Brun的学生，也是Les Invalides荣军院和Versailles教堂圆顶壁画的原创人。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://www.paris.catholique.fr/-eglise-notre-dame-de-l-assomption-.html">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0006_notre-dame-de-paris.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>参与Notre-Dame de Paris的修复工作</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>NOTRE-DAME巴黎圣母院</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>为了庆祝Notre-Deme巴黎圣母院建成850周年纪念，在法国大革命期间被部分摧般的教堂大钟经过整修，重现原始风貌。基金会出资修复了其中一个圣钟――Gabriel bell，其钟声亦于2013年3月23日再次响起。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.notredamedeparis2013.com/projets/nouvelle-sonnerie-de-cloches/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0005_institut-du-monde-arabe.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>學生參觀博物館</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>阿拉伯世界研究院</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            Sisley多納諾基金會支持優先教育網絡（Réseau éducation
            prioritaires）區域的初中學生前往參觀「東方基督徒：
            兩千年歷史」展覽。
            於2017年9月26日至2018年1月14舉行的這場展覽涵蓋了歷史課程的重要部分，著眼於這個中東族群在政治、文化、社會以及宗教層面上扮演的角色。
            阿拉伯世界研究院（L’Institut du monde arabe,
            IMA）是由法國和阿拉伯聯盟的22個國家於1987年策劃，旨在透過其博物館、展覽和豐富的文化活動，來推廣並宣揚阿拉伯文化。
            阿拉伯世界研究院透過這場展覽，持續實現對偏遠地區公眾的承諾。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://www.imarabe.org/fr/expositions/chretiens-d-orient-deux-mille-ans-d-histoire">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0004_la-quinzaine-en-action.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>弱勢婦女編劇工作坊</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>QUINZAINE EN ACTIONS</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            Sisley多納諾基金會於2010年與透過影像推動文化與教育的組織──Quinzaine
            en Actions攜手合作，該組織受到康城影展的Quinzaine en Actions所啟發。
            機構在康城郊區的La Bocca，全年為弱勢族群舉辦工作坊、放映會及討論會。
            在Quinzaine des
            Réalisateurs的電影人規劃下，專為「婦女歷程」（Parcours de
            Femmes）協會中受孤立、經濟不穩定或遭受家庭暴力的女性舉行的編劇工作坊受到Sisley基金會所資助。
            尼斯學院所有一、二年級高中生接著以工作坊完成的劇本來創作影片並參與短片競賽。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://www.quinzaine-realisateurs.com/la-quinzaine-en-actions/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0003_compagnie-labyrinthe.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>弱勢年輕人站上舞台</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>迷宮公司</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            導演賽爾・桑多（Serge
            Sandor）於1986年成立了迷宮（Labyrinthe）公司，邀請坐牢、無家可歸、在精神病院診療的人士參與其劇場作品。
            在Sisley多納諾基金會的贊助下，迷宮公司在2014年推出《La
            dispute.com》並在2016年推出《Roméo M
            Juliette》。該公司在2017至2018年間拍攝多部電影，他們在約訥（Yonne）和涅夫勒（Nièvre）的戲劇工作坊，與當地社區青少年、受兒童福利援助的青少年、失依的外國未成年人以及約20位退休人士一起探索戲劇、編劇和拍片。
            透過戲劇工作坊，讓這些年輕人不再遭受孤立，而和不同的人接觸互動，重拾對自己以及他人─
            ─尤其是成年人的信心。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://scenatoutage.blogspot.com/?_sm_au_=iVVrN7nzTHMSk7RP">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0002_oeil-des-cariatides.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>了解孤立及其導致的影響</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>L'OEIL DES CARIATIDES組織</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            L’Oeil des Cariatides協會由女導演及演員艾洛蒂・夏努（Elodie
            Chanut）於2004年成立。
            該協會的研究旨在賦予年輕大眾重要的地位，並側重文化工具和語言的傳播，這些都是真正促進融合的動力。
            Sisley多納諾基金會目前正在支持一個新的戲劇計劃，以促進大眾了解孤立及其導致的影響。
            該計劃是基於預防式教育工具設計，擬採取工作坊形式分階段進行，並參考相關文本、闡述被牽動的情緒，以及如何讓人了解被視為稀鬆平常的暴力、各種形式的孤立以至於極度騷擾的形成機制。
            工作坊討論會將由預防專業人士主導。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://www.loeildescariatides.com/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0001_revelations-culturelles.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>支持女性导演</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>RÉVÉLATIONS CULTURELLES</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>在欧洲，仅有五分之一的电影由女性创作。「Femmes de Cinéma」实验室创建于2017年，自创立之初便获得了基金会的大力支持。该机构隶属于Révélations Culturelles（文化启示）协会，致力于通过理念和实验来推动改变。此外，它还不断推广女性电影工作者的重要角色，以便为欧洲电影前景带来积极改变。</p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="http://femmesdecinema.org/">了解更多</a>
        </div>
      </div>
    </div>
    <div class="ms-row c-solidarity-content hide">
      <div class="col-xs-12 col-lg-4 col-lg-offset-1">
        <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/vignettes-asso_0000_poesie-en-liberte.jpg" class="m-foundation-content__image--primary lazyloaded" alt="Sisley基金會" />
      </div>
      <div class="col-xs-12 col-lg-7">
        <div class="m-minisite__description c-solidarity-content__title-primary">
          <p>國際法語詩歌比賽</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__title-secondary">
          <p>自由詩歌</p>
        </div>
        <div class="m-minisite__description c-solidarity-content__description">
          <p>
            Sisley多納諾基金會資助國際「自由詩歌」（Poésie en
            liberté）競賽成立二十週年所出版的詩集。
            這項競賽開放給所有15至26歲的年輕人參加，不論他們來自的國家/地區或教育程度（高中生，學生，學徒等）。該競賽不限詩歌主題或形式，參與者透過線上發送一首三十行詩歌即可參賽。
          </p>
        </div>
        <div class="m-minisite__description">
          <a class="link-with-arrow m-foundation-content__projects-title--third" href="https://www.poesie-en-liberte.fr/">了解更多</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: "FoundationCulture" };
</script>

<style lang="scss" scoped>
  .c-solidarity-content {
    padding-bottom: 4.8125rem;
    .c-solidarity-content__title-primary {
      font-size:.75rem;line-height:1.67;color:#000;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;padding-top:2.1875rem;
      p { margin-bottom:.3125rem; }
    }
    .c-solidarity-content__title-secondary {font-size:1.25rem;color:#000;font-family:PlayfairDisplay-Italic,arial,sans-serif;}
    .c-solidarity-content__description {font-size:.8125rem;line-height:1.62;color:#000;font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif;}
    .m-foundation-content__projects-title--third {z-index:2;font-weight:700;font-size:.75rem;text-decoration:underline;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;top:.625rem;}
    .m-minisite__description a { display: none; }
  }
  @media screen and (min-width:48em) {
    .c-solidarity-content { padding-bottom: 6.0625rem; }
  }
  @media screen and (min-width:64em) {
    .c-solidarity-content {
      padding-bottom: 8rem;
      .c-solidarity-content__title-primary { padding-top: 0; }
    }
  }
</style>